import { ReactComponent as EmptyDragon } from '@prophecy/icons/assets/images/empty_dragon.svg?react';
import { theme } from '@prophecy/theme';
import { Display, Stack, Text } from '@prophecy/ui-v3';
import React from 'react';

import { FileFormats } from '../../../config';
import { useImportState } from '../../useImportState';
import { TranspilerEnabledFolders } from '../TranspilerEnabledFolders';
import { AddAllPipelines } from './AddAllPipelines';

export const EmptyForm = () => {
  const {
    formDataWithActions: {
      formContext: { getValues }
    }
  } = useImportState();

  const { source } = getValues();
  const supportedFiles = TranspilerEnabledFolders[source as FileFormats];
  return (
    <Stack width='100%' height='100%' gap={theme.spaces.x32} align='center' alignY='center'>
      <EmptyDragon />
      <Display level='xs' weight={theme.fontWeight.semiBold} tone={theme.colors.gray900}>
        Selecting the files to transpile
      </Display>
      <Stack gap={theme.spaces.x4} width='100%' align='center' alignY='center'>
        <Text level='md' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
          You can choose the mapping {supportedFiles.length > 0 ? 'files' : 'file'} (*.{supportedFiles.join(', *.')})
          from the available
        </Text>
        <Text level='md' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
          files on the left hand side.
        </Text>
      </Stack>
      <AddAllPipelines />
    </Stack>
  );
};
